import { Autocomplete, Box, TextField } from '@mui/material';
import { getIn, useField, useFormikContext } from 'formik';

interface Option {
  code: string;
  label: string;
  phone: string;
  suggested?: boolean;
}

interface CountrySelectProps {
  options: Option[];
  name: string;
  value: Option | null;
}

export const CountrySelectFormik = ({ options, name, value }: CountrySelectProps) => {
  const { errors, handleBlur, touched, setFieldValue } = useFormikContext();

  const [field] = useField(name);

  const onChange = (_: any, nextValue: any) => {
    setFieldValue(field.name, nextValue ? nextValue.code : 'US');
  };

  return (
    <Box
      sx={{
        width: '100%',
        '& .MuiAutocomplete-option': {
          typography: 'body2',
          '& > span': { mr: 1, fontSize: 20, typography: 'body2' },
        },
      }}
    >
      <Autocomplete
        value={value}
        fullWidth
        autoHighlight
        onChange={onChange}
        options={options}
        isOptionEqualToValue={(option, { code }) => option.code === code}
        getOptionLabel={(option) => option.label}
        renderOption={(props, option) => (
          <li {...props}>
            <span>{option.label}</span>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            label="Country"
            error={getIn(touched, field.name) && !!getIn(errors, field.name)}
            helperText={getIn(touched, field.name) && getIn(errors, field.name)}
            onBlur={handleBlur}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password',
            }}
          />
        )}
      />
    </Box>
  );
};
